import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PwaInstallGuideModalComponent } from './pwa-install-guide-modal/pwa-install-guide-modal.component';

let _installPrompt:any = null;

window.addEventListener('beforeinstallprompt', (event) => {
    _installPrompt = event;
});

@Injectable({
    providedIn: 'root'
})
export class PwaInstallService {

    isInstalled = false;

    constructor(private modalService:NgbModal) {
        this.isInstalled = window.matchMedia('(display-mode: standalone)').matches 
            || (navigator as any).standalone // Specifico per iOS Safari vecchi
            || document.referrer.includes('android-app://'); // TWA Android
    }

    canInstall() {
        return !this.isInstalled;
    }

    async doInstall() {
        if(_installPrompt) {
            _installPrompt.prompt()
            let _result = await _installPrompt.userChoice;
        }
        else {
            this.modalService.open(PwaInstallGuideModalComponent, { size: 'xl' })
        }
    }
}
